import React from 'react'

import { path } from './UrlBar.module.scss'

const Path = ({ 
  value 
}) => (
  <div className={ path }>
    { value.split(/[{}]/g).map((part, index) => {
      if (part && index % 2) {
        return (
          <strong key={index}>:{ part }</strong>
        )
      } else if (part) {
        return (
          <span key={index}>{ part }</span>
        )
      }
    })}
  </div>
)

export default Path